import { Marker } from '@retailer-platform/shared-components/src/tds'
import { SPACING } from '../constants'

interface RoleMarkersProps {
  associatedRoles: Set<{ label: string; permissions: { slug: string }[] }>
}

export const RoleMarkers = ({ associatedRoles }: RoleMarkersProps) => {
  const associatedRolesMarkers: JSX.Element[] = []

  associatedRoles.forEach(role => {
    associatedRolesMarkers.push(
      <div key={role.label + '_' + 'associated-role'} css={{ display: 'flex' }}>
        <Marker key={role.label + '_' + 'associated-role'} text={role.label} variant="neutral" />
      </div>
    )
  })

  return (
    <div css={{ display: 'flex', flexWrap: 'wrap', gap: SPACING.SMALL }}>
      {associatedRolesMarkers}
    </div>
  )
}
